export default function getMixpanelUserId(): string | undefined {
    return mixpanel.master.get_distinct_id();
}
